/**
 * @generated SignedSource<<fc8424d021e99071be3494dc6cc667de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type State_EnvironmentQuery$variables = {};
export type State_EnvironmentQuery$data = {
  readonly environment: {
    readonly commit: string;
    readonly env: string;
  } | null;
};
export type State_EnvironmentQuery = {
  response: State_EnvironmentQuery$data;
  variables: State_EnvironmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Environment",
    "kind": "LinkedField",
    "name": "environment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "env",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "State_EnvironmentQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "State_EnvironmentQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2c33585480a8e324fdaab569038460cb",
    "id": null,
    "metadata": {},
    "name": "State_EnvironmentQuery",
    "operationKind": "query",
    "text": "query State_EnvironmentQuery {\n  environment {\n    env\n    commit\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce79bae15d6d62b67a89c0ed9b788ca2";

export default node;
